<template>
  <div v-if="options.component == 'HiddenField'">
    <hidden-field :options="options"></hidden-field>
  </div>
  <div v-else>
    <div 
      :id="'field-' + options.id"
      v-show="show" 
      :class="[{ required: options.required, invalid: isInvalid, 'vertical': isVertical }, 'vf-' + componentCSSClass]"  
      class="grid-x grid-padding-xz vf-field-holder">
      <div 
        v-if="options.hide_label == 0 || !isVertical"
        class="cell vf-label small-text-left"
        :class="{ 'medium-4': !isVertical, 'medium-text-right': !isVertical }">
        <label 
          v-if="options.hide_label == 0"
          :for="'field-' + options.id">
          <div class="grid-x">
            <div v-if="options.required && options.label" class="cell shrink">
              <span 
                v-html="$icons.get('asterisk', 'small ' + (this.isInvalid ? 'dark-red' : 'dark-gray'))"
                style="display:block;padding:.1em .2em 0 0">
              </span>
            </div>
            <div class="cell auto">
              {{ options.label }}
            </div>
          </div>
        </label>
      </div>
      <div 
        class="cell vf-field"
        :class="{ 'medium-8': !isVertical }">
        <div class="vf-field-wrapper">
          <component 
            :is="options.component" 
            :options="options"
            :value="value"
            :ref="'field-component-' + options.id">
          </component>
          <span v-if="options.help_text" class="vf-field-description">{{ options.help_text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {_} from 'vue-underscore'
import CheckboxGroup from '@/FieldTypes/CheckboxGroup.vue'
import ContentField from '@/FieldTypes/ContentField.vue'
import DatePickerField from '@/FieldTypes/DatePickerField.vue'
import DateTextField from '@/FieldTypes/DateTextField.vue'
import DropdownField from '@/FieldTypes/DropdownField.vue'
import EmailConfirmationField from '@/FieldTypes/EmailConfirmationField.vue'
import EmailField from '@/FieldTypes/EmailField.vue'
import FileUploadField from '@/FieldTypes/FileUploadField.vue'
import HiddenField from '@/FieldTypes/HiddenField.vue'
import RadioButtonGroup from '@/FieldTypes/RadioButtonGroup.vue'
import ReadonlyField from '@/FieldTypes/ReadonlyField.vue'
import TextareaField from '@/FieldTypes/TextareaField.vue'
import TextField from '@/FieldTypes/TextField.vue'

export default { 
  name: 'FieldHolder',
  components: {
    CheckboxGroup, 
    ContentField, 
    DatePickerField, 
    DateTextField, 
    DropdownField, 
    EmailConfirmationField, 
    EmailField, 
    FileUploadField, 
    HiddenField, 
    ReadonlyField, 
    RadioButtonGroup, 
    TextareaField, 
    TextField
  },
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    /* Determine if field should be hidden (if conditional) */
    showField () {
      let vm = this
      if (this.options.conditional) {
        this.show = false
        _.each(vm.options.display_rules, function(rule) { 
          let trigger_field = 'field-' + rule.field_id
          let trigger_value = rule.trigger_value
          let current_value = vm.$store.formData[trigger_field]
          let match = vm.$util.setValue(current_value).checkIfMatch(
            trigger_value, rule.condition, rule.type
          )
          if (match) {
            vm.show = true
          }
        })
      } else {
        vm.show = true
      }
    },
    validate () {
      if (this.show) {
        let component = this.$refs['field-component-' + this.options.id]
        let result = (this.value !== undefined ? component.validate() : false)
        if (result == false) {
          this.$commit.setInvalidField({ id: this.options.id, label: this.options.label })
        }
        return result
      } else {
        return true
      }
      
    }
  },
  computed: {
    component () {
      return this.$refs['field-component-' + this.options.id]
    },
    /* Check if in invalid field list */
    isInvalid () {
      const self = this
      let invalid = _.findWhere (
        self.$store.invalidFields,
        { id: self.options.id }
      )
      return (invalid !== undefined ? true : false)
    },
    /* Return css class(es) for component */
    componentCSSClass () {
      const str = this.options.component
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        .map(x => x.toLowerCase())
        .join('-')
      return str
    },
    formData () {
      return this.$store.formData
    },
    isVertical () {
      return this.options.orientation == 'vertical'
    },
    showLabel () {
      return (this.options.hide_label != 1)
    },
    value () {
      return this.formData['field-' + this.options.id]
    }
  },
  watch: {
    formData: {
      handler () {
        this.showField()
     },
     deep: true
    }
  },
  mounted () {
    this.showField()
  }
}
</script>
